// src/routes/index.tsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import MainRoutes from "./MainRoutes";
import UserRoutes from "./UserRoutes";
import AdminRoutes from "./AdminRoutes";

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Home routes - catch-all for the main site */}
      <Route path="/*" element={<MainRoutes />} />
      <Route path="/user*" element={<UserRoutes />} />
      <Route path="/admin*" element={<AdminRoutes />} />
    </Routes>
  );
};

export default AppRoutes;
